/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MediaFileReference,
    MediaFileReferenceFromJSON,
    MediaFileReferenceFromJSONTyped,
    MediaFileReferenceToJSON,
} from './';

/**
 * 
 * @export
 * @interface MediaFileTemplateUpdate
 */
export interface MediaFileTemplateUpdate {
    /**
     * 
     * @type {MediaFileReference}
     * @memberof MediaFileTemplateUpdate
     */
    file: MediaFileReference;
    /**
     * 
     * @type {string}
     * @memberof MediaFileTemplateUpdate
     */
    name: string;
}

export function MediaFileTemplateUpdateFromJSON(json: any): MediaFileTemplateUpdate {
    return MediaFileTemplateUpdateFromJSONTyped(json, false);
}

export function MediaFileTemplateUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): MediaFileTemplateUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'file': MediaFileReferenceFromJSON(json['file']),
        'name': json['name'],
    };
}

export function MediaFileTemplateUpdateToJSON(value?: MediaFileTemplateUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'file': MediaFileReferenceToJSON(value.file),
        'name': value.name,
    };
}


